//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { SystemPermissionModel } from './SystemPermissionModel';
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class RoleModel extends ModelBase {
      static readonly $typeName = 'RoleModel';
      public description: string;
      public includedPermissions: SystemPermissionModel[];
      public includedRoles: RoleModel[];
      public key: string;
      public name: string;
      public isAdministrative: boolean;
      public isEssential: boolean;
      public type: LookupModel;
      public warnings: string[];
      public wellKnownName: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/security/models/RoleModel.ts